import React from 'react';
import classNames from 'classnames';
import Logo from '@app/src/assets/icons/logo.svg';
import McubeLogo from '../assets/mcube-logo.svg';

interface IProps {
  className?: string;
}

const AuthWindowLogo = ({ className }: IProps) => {
  const isMcube = window.location.origin.includes('mcube');
  return (
    <div className={classNames('auth-window__form__logo', className)}>
      {isMcube ? <McubeLogo /> : <Logo />}
    </div>
  );
};

export default AuthWindowLogo;
